let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Huth")).then(() => parcelRequire('dz89i'));